import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";

export default {
  namespaced: true,
  state: {
    Equipamentos: [],
  },
  mutations: {
    carregar(state, Equipamentos) {
      state.Equipamentos = [];
      state.Equipamentos = Equipamentos;
    },
  },
  actions: {
    async listar({ commit }, opcoes) {
      try {
        const response = await securedAxios.get(
          `/equipamento?opcoes=${urljson(opcoes)}`
        );
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gravar(context, EquipamentoInfo) {
      try {
        let response;
        if (EquipamentoInfo.id == "") {
          delete EquipamentoInfo.id;
          response = await securedAxios.post("/equipamento", EquipamentoInfo);
        } else {
          var id = EquipamentoInfo.id;
          delete EquipamentoInfo.id;
          response = await securedAxios.put(
            "/equipamento/" + id,
            EquipamentoInfo
          );
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarEquipamento(context, id) {
      return await securedAxios.get(`/equipamento/${id}`);
    },
    async deletar(context, id) {
      try {
        const response = await securedAxios.delete("/equipamento/" + id.id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
